let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("32CsP")).then(() => parcelRequire('kKdu4'));